<template>
  <div class="header-container" :class="{ 'header-container-image': image }" :style="backgroundStyle">
    <img v-if="image" :src="image | mediaSrc" :alt="imageAlt" class="header-image">
    <div v-else class="header">
      <v-container>
          <v-row>
            <v-col cols="12" class="header-title-container px-0">
              <div><span class="header-title"><slot></slot></span></div>
              <div v-if="subtitle" class="header-subtitle">{{ subtitle }}</div>
              <!-- <div><span class="hero-2-action"><v-btn elevation="0" color="red">Contact us</v-btn></span></div> -->
            </v-col>
          </v-row>
        </v-container>
    </div>
  </div>
</template>

<script>
import { mediaRef } from '@/services/mediaAssets';

export default {
  name: 'AppHeader',
  props: {
    subtitle: {
      type: String,
      default: '',
    },
    image: {
      type: [String, Object],
      default: '',
    },
    imageAlt: {
      type: String,
      default: '',
    },
  },
  data: () => ({ headerBackground: mediaRef('reckon_hero_bg.png') }),
  computed: {
    backgroundStyle() {
      const source = this.$options.filters.mediaSrc(this.headerBackground);
      return source ? { backgroundImage: `url(${source})` } : null;
    },
  },
};
</script>

<style scoped>
.header-container {
  max-height: 450px;
  display: flex;
  width: auto;
  background-size: cover; /* Cover the entire container */
  background-position: center; /* Center the background */
  background-repeat: no-repeat; /* No repeating */
  margin-bottom: 30px;

}

.header {
  max-height: 450px;
  min-height: 300px;
  max-width: 1000px;
  width: 100% !important;
  /* background-color: rgba(14, 31, 38, 0.495); */
  margin-left: auto;
  margin-right: auto;
  padding: 30px;
  display:flex;
  flex-direction: column;
  justify-content:end;
}

.header-container-image {
  background: #050505;
  max-height: none;
}

.header-image {
  display: block;
  height: auto;
  width: 100%;
}

.header-title-container {
  font-weight:900;
  /* background-color: #525252b4; */
  text-align: center;
  border-bottom: solid 5px red;
}

.header-title {
  color: #fff;
  font-size: 2.5rem;
  font-weight:900;
  /* background-color: #333333; */
  padding: 10px;
  text-align: center;
}

.header-subtitle {
  color: #f2f2f2;
  font-family: "Oswald", serif;
  font-size: 1.2rem;
  font-weight: 700;
  letter-spacing: 0;
  padding: 0 10px 14px;
  text-align: center;
}
</style>
